import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/AppProviders";
import { api } from "@/lib/api";
import { FadeIn, Overline } from "@/components/Kinetic";
import { Quote } from "lucide-react";

export default function Temoignages() {
  const { t } = useLanguage();
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div className="pt-32 md:pt-40 pb-28 min-h-screen" data-testid="testimonials-page">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <FadeIn><Overline>{t.testimonials.overline}</Overline></FadeIn>
        <FadeIn delay={0.1}>
          <h1 className="mt-6 font-display font-semibold tracking-tighter text-5xl md:text-7xl text-ink">{t.testimonials.title}</h1>
        </FadeIn>

        {items === null ? (
          <p className="mt-24 text-ink/40">{t.common.loading}</p>
        ) : items.length === 0 ? (
          <FadeIn delay={0.2} className="mt-24 border border-dashed border-ink/20 py-24 text-center" data-testid="testimonials-empty">
            <Quote size={36} className="mx-auto text-ink/15" />
            <p className="mt-6 text-ink/50 text-lg">{t.testimonials.empty}</p>
            <p className="mt-2 text-sm text-ink/40">{t.testimonials.emptySub}</p>
            <Link to="/formation" data-testid="testimonials-cta" className="btn-glow mt-10 inline-block bg-ink hover:bg-ember text-white px-8 py-4 text-sm tracking-wide transition-colors duration-300">
              {t.testimonials.cta}
            </Link>
          </FadeIn>
        ) : (
          <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {items.map((it, i) => (
              <FadeIn key={it.id} delay={(i % 3) * 0.08} className="border border-ink/10 bg-surface p-8" data-testid={`testimonial-${it.id}`}>
                <Quote size={22} className="text-ember" />
                <p className="mt-5 text-ink/70 leading-relaxed">{it.text}</p>
                <div className="mt-6 pt-5 border-t border-ink/10">
                  <p className="font-display font-medium text-ink">{it.name}</p>
                  {it.role && <p className="text-xs text-ink/45 mt-1">{it.role}</p>}
                </div>
              </FadeIn>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
